module.exports = __webpack_public_path__ + "static/media/Public_26.b29c84a6.jpg";